import { ConcreteEncodable } from "./ConcreteEncodable";

import { OpsExcRecordImplEncoder } from "../../encoder/OpsExcRecordImplEncoder";

import * as CubiqTS from "../../index";
import { OpsExcRecord } from "../OpsExcRecord";

export class OpsExcRecordImpl extends ConcreteEncodable implements OpsExcRecord {
  public static enType: string = "com.bcdfx.model.OpsExcRecordImpl";

  /*FID=1*/
  public id: CubiqTS.Long | null = null;
  /*FID=2*/
  public stamp: CubiqTS.Long | null = null;
  /*FID=3*/
  public dealId: CubiqTS.Long | null = null;
  /*FID=4*/
  public bookingUti: string;
  /*FID=5*/
  public orderId: CubiqTS.Long | null = null;
  /*FID=6*/
  public resolvingUserId: CubiqTS.Long | null = null;
  /*FID=7*/
  public resolvingData: string;
  /*FID=8*/
  public clearingUserId: CubiqTS.Long | null = null;
  /*FID=9*/
  public clearingData: string;
  /*FID=10*/
  public capabilitiesData: string;
  /*FID=11*/
  public payloadData: string;
  /*FID=12*/
  public exceptionTypeId: CubiqTS.OpsExceptionType;
  /*FID=13*/
  public descriptionTxt: CubiqTS.Errors | null = null;
  /*FID=14*/
  public reasonTxt: CubiqTS.Errors | null = null;
  /*FID=15*/
  public exceptionState: CubiqTS.OpsExceptionState;
  /*FID=16*/
  public createdDt: CubiqTS.moment.Moment | null = null;
  /*FID=17*/
  public resolveDt: CubiqTS.moment.Moment | null = null;
  /*FID=18*/
  public autoTimeoutDt: CubiqTS.moment.Moment | null = null;
  /*FID=19*/
  public clearingDt: CubiqTS.moment.Moment | null = null;
  /*FID=20*/
  public autoActionId: CubiqTS.OpsIntAction;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OpsExcRecordImplEncoder.Instance;
    this.setEncodableType(OpsExcRecordImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OpsExcRecordImpl[" +
      "id=" +
      this.id +
      "stamp=" +
      this.stamp +
      "dealId=" +
      this.dealId +
      "bookingUti=" +
      this.bookingUti +
      "orderId=" +
      this.orderId +
      "resolvingUserId=" +
      this.resolvingUserId +
      "resolvingData=" +
      this.resolvingData +
      "clearingUserId=" +
      this.clearingUserId +
      "clearingData=" +
      this.clearingData +
      "capabilitiesData=" +
      this.capabilitiesData +
      "payloadData=" +
      this.payloadData +
      "exceptionTypeId=" +
      this.exceptionTypeId +
      "descriptionTxt=" +
      this.descriptionTxt +
      "reasonTxt=" +
      this.reasonTxt +
      "exceptionState=" +
      this.exceptionState +
      "createdDt=" +
      this.createdDt +
      "resolveDt=" +
      this.resolveDt +
      "autoTimeoutDt=" +
      this.autoTimeoutDt +
      "clearingDt=" +
      this.clearingDt +
      "autoActionId=" +
      this.autoActionId +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
